module.exports = __webpack_public_path__ + "img/softCertificate.080e5fd4.png";